"use client";

import { useState } from "react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "../ui/form";
import { useForm } from "react-hook-form";
import z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { DocumentationFormSchema } from "@/schemas/documentation-form.schema";
import { Input } from "../ui/input";
import { postCreateDocumentation } from "@/services/documentation.service";
import { useCurrentUser } from "@/hooks/useCurrentUser";

interface Props {
    parentID: string,
}

export default function NewDocumentationModal(props: Props) {
  const [open, setOpen] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { user } = useCurrentUser();

    const form = useForm<z.infer<typeof DocumentationFormSchema>>({
      resolver: zodResolver(DocumentationFormSchema),
      defaultValues: {
        title: "",
        parentID: props.parentID,
      },
    });

    const formSubmit = async (data: z.infer<typeof DocumentationFormSchema>) => {
        setIsCreating(true);

        const formData = new FormData();
        formData.append('title', data.title);
        formData.append('parentID', data.parentID);
        formData.append('creatorID', user!.U_ID ?? "");

        try {
            const result = await postCreateDocumentation(formData);
            console.log(result);

            if(result.message != "Documentation Created"){
                setErrorMessage("Couldn't create documentation");
            } else {
                setOpen(false);
                // Find a way to gracefully reload the sidebar content. Then use the navigate line instead
                document.location = "/documentation/".concat(result.id);
                // navigate("/documentation/".concat(result.id));
            }
        } catch (error) {
            console.log(error);
            setErrorMessage("Error occurred");
        } finally {
            setIsCreating(false);
        }
        
    }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="cursor-pointer">Create new documentation</Button>
      </DialogTrigger>
      <DialogContent className="max-w-sm">
        <DialogTitle>New documentation page</DialogTitle>
        <Form {...form}>
          <form
            className="grid gap-y-4"
            onSubmit={form.handleSubmit(formSubmit)}
          >
            <div className="grid grid-cols-6 gap-4">
              <div className="col-start-1 col-end-4 rounded-md border-black">
                <FormField
                  control={form.control}
                  name="title"
                  render={({ field }) => (
                    <FormItem className="mb-2">
                      <FormLabel>Title</FormLabel>
                      <FormControl>
                        <Input
                          disabled={isCreating}
                          placeholder="title"
                          {...field}
                        />
                      </FormControl>

                      <FormMessage />
                    </FormItem>
                  )}
                />
                
              </div>

              {errorMessage != "" ? (
                <h1 className="w-full text-xl font-bold text-black dark:text-white mb-2 py-1 px-2 rounded-md bg-red-500">
                    {errorMessage}
                </h1>
              ): (<></>)}
              <div className="col-start-1 col-end-7">
                <Button
                  disabled={isCreating}
                  className="w-full mt-4 cursor-pointer"
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
